import { QueryClient } from "@tanstack/vue-query";

/**
 * App-wide TanStack Query client, created as a module singleton so non-component
 * code (services, store modules) can reach the SAME instance that VueQueryPlugin
 * uses. `main.ts` imports this and passes it to VueQueryPlugin — keeping a single
 * instance is what makes cross-component cache invalidation work.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 30
    }
  }
});

export const getQueryClient = (): QueryClient => queryClient;

/**
 * staleTime for period-scoped GETs (duties, events, absences, ...).
 * Short on purpose: long enough to collapse the duplicate-request storm during
 * rapid month navigation (in-flight dedup is automatic regardless), short enough
 * that stale data can't linger after edits — mutations also invalidate explicitly
 * via `invalidatePeriod`.
 */
export const PERIOD_STALE_TIME = 30_000;

/** Invalidate every cached entry under the given resource prefixes. */
export const invalidatePeriod = (...prefixes: string[]): void => {
  prefixes.forEach((prefix) => queryClient.invalidateQueries({ queryKey: [prefix] }));
};
